import React, { useRef, useState, useCallback, useEffect } from "react";
import Webcam from "react-webcam";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import "./CustomModal.css";
import { Button } from "react-bootstrap";
import leftImage from "../../../assets/images/leftside.png";
import rightImage from "../../../assets/images/rightside.png";
import cameraClick from "../../../assets/images/camera-click.png";

const CameraModal = ({ show, handleClose, setPhotoInBox, ironId, ironTitle, ironLabel, title }) => {
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const imageSectionRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const [frameImgSrc, setFrameImgSrc] = useState(null);
  const [isWebcamReady, setIsWebcamReady] = useState(false);
  const [isFrameLoaded, setIsFrameLoaded] = useState(false);
  const [useFrontCamera, setUseFrontCamera] = useState(true);


  const [videoConstraints, setVideoConstraints] = useState({
    width: 0,
    height: 0,
    facingMode: useFrontCamera ? "environment" : "user",
  });

  const [frameSides, setFrameSides] = useState("RH");

  useEffect(() => {
    const defaultFrameUrl = frameSides === "LH"
      ? leftImage
      : rightImage;
    setFrameImgSrc(defaultFrameUrl);
    setIsFrameLoaded(true);
  }, [frameSides]);



  useEffect(() => {

    if (show) {



    }

  }, [show]);





  const handleUserMedia = () => {
    setIsWebcamReady(true);

    const elements = document.getElementsByClassName("image-section");
    const offsetWidth = elements[0].offsetWidth;

    setVideoConstraints({
      width: offsetWidth,
      height: offsetWidth,
      facingMode: useFrontCamera ? "environment" : "user",
    });

    if (canvasRef.current) {
      canvasRef.current.width = offsetWidth;
      canvasRef.current.height = offsetWidth;
    }
  };

  const captureWithFrame = useCallback(() => {
    const video = webcamRef.current?.video;
    if (!video) {
      console.error("Video element not found. Webcam may not be ready yet.");
      return;
    }
    
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    if (isWebcamReady && video.readyState === 4) {
      // Ensure the canvas matches the video feed dimensions
      const videoWidth = video.videoWidth;
      const videoHeight = video.videoHeight;
      canvas.width = videoWidth;
      canvas.height = videoHeight;

      // Draw the camera feed on the canvas
      context.drawImage(video, 0, 0, videoWidth, videoHeight);

      // Get the final image from the canvas
      const imageSrc = canvas.toDataURL("image/jpeg");
      setCapturedImage(imageSrc);
      setPhotoInBox(imageSrc, ironId);
      handleClose();
    } else {
      console.log("Webcam or frame image not ready yet.");
    }
  }, [isWebcamReady, isFrameLoaded, frameImgSrc, handleClose, setPhotoInBox]);

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {


    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Update video constraints and canvas size based on image-section size
  useEffect(() => {
    if (imageSectionRef.current) {
      const { offsetWidth, offsetHeight } = imageSectionRef.current;

      // Set video constraints and canvas size to match the image section
      // setVideoConstraints({
      //   width: offsetWidth,
      //   height: offsetWidth,
      //   facingMode: useFrontCamera ? "environment" : "user",
      // });

      // if (canvasRef.current) {
      //   canvasRef.current.width = offsetWidth;
      //   canvasRef.current.height = offsetWidth;
      // }
    }
  }, [width, height, useFrontCamera]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageSrc = e.target.result;
        // setCapturedImage(imageSrc);

        // Draw image on canvas
        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        const img = new Image();
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          context.drawImage(img, 0, 0, img.width, img.height);

          // Get final image from the canvas
          const finalImage = canvas.toDataURL("image/jpeg");
          setCapturedImage(finalImage);
          setPhotoInBox(finalImage, ironId);
          handleClose();
        };
        img.src = imageSrc;
      };
      reader.readAsDataURL(file);
    }
  };



  return (

    <>
      {
        false ? <></> : <>
          <Modal
            onHide={handleClose}
            size="lg"
            show={show}
            id="success_tic"
            className="card-radius
       popup-modal-dark  
       add_club_modal 
        camera_modal modal-camera-open 
       "
          >
            <Modal.Body className="p-0"
              dialogClassName="custom-modal "
            >
              <div className="close-modal">
                <div className="custom-modal-header">
                  <h3 className="d-flex align-items-center box-title mb-0"><span className="color " style={{ backgroundColor: ironLabel, }}>{ironId}</span> &nbsp; {title}</h3>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                    aria-label="Close"

                  >
                    <IoClose />
                  </button>
                </div>
              </div>

              <div ref={imageSectionRef} className="image-section">

                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                  // style={{
                  //   width: videoConstraints.width,
                  //   height: videoConstraints.height,
                  // }}
                  height={videoConstraints.width}
                  width={videoConstraints.width}
                  onUserMedia={handleUserMedia}
                />
                {
                  isWebcamReady ? <>


                    {frameImgSrc && (
                      <img
                        src={frameImgSrc}
                        alt="Frame"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: videoConstraints.width,
                          height: videoConstraints.height,
                        }}
                      />
                    )}

                  </> : <></>
                }

                {/* Always render canvas for file uploads and webcam captures */}
                <canvas
                  ref={canvasRef}
                  style={{ display: "none" }}
                />


              </div>

              <div className="button-section">
                <div className="switch-custom">
                  <Button
                    className={frameSides === "LH" ? "switch-active" : ""}
                    variant="outline-dark"
                    onClick={() => setFrameSides("LH")}
                  >
                    LH
                  </Button>
                  <Button
                    variant="outline-dark"
                    className={frameSides === "RH" ? "switch-active" : ""}
                    onClick={() => setFrameSides("RH")}
                  >
                    RH
                  </Button>
                </div>
                {/* <div className="switch-custom" style={{ backgroundColor: "transparent" }}>

                  <input
                    type="file"
                    className={frameSides === "LH" ? "switch-active" : ""}
                    variant="outline-dark"
                    style={{ border: "2px solid #ffffff", }}
                  ><svg xmlns="http://www.w3.org/2000/svg" style={{ color: "#ffffff" }} id="bold" fill="#ffffff" enable-background="new 0 0 24 24" height="20" viewBox="0 0 24 24" width="20" ><g><g><path d="m6.25 19.5c-1.601 0-3.025-1.025-3.542-2.551l-.035-.115c-.122-.404-.173-.744-.173-1.084v-6.818l-2.426 8.098c-.312 1.191.399 2.426 1.592 2.755l15.463 4.141c.193.05.386.074.576.074.996 0 1.906-.661 2.161-1.635l.901-2.865z" /></g><path d="m9 9c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2z" /></g><path d="m21.5 2h-15c-1.378 0-2.5 1.122-2.5 2.5v11c0 1.378 1.122 2.5 2.5 2.5h15c1.378 0 2.5-1.122 2.5-2.5v-11c0-1.378-1.122-2.5-2.5-2.5zm-15 2h15c.276 0 .5.224.5.5v7.099l-3.159-3.686c-.335-.393-.82-.603-1.341-.615-.518.003-1.004.233-1.336.631l-3.714 4.458-1.21-1.207c-.684-.684-1.797-.684-2.48 0l-2.76 2.759v-9.439c0-.276.224-.5.5-.5z" /></svg>
                    <span className="ms-2" style={{ color: "#ffffff" }}>UPLOAD</span>
                  </input>
                </div> */}

                <div className="switch-custom" style={{ backgroundColor: "transparent" }}>
                  <label
                    htmlFor="file-upload"
                    className={`switch-label ${frameSides === "LH" ? "switch-active" : ""}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "2px solid #ffffff",
                      padding: "7px 15px",
                      cursor: "pointer",
                      borderRadius: "8px",
                    }}
                  >
                    <input
                      type="file"
                      id="file-upload"
                      style={{ display: "none" }} // Hide the default file input
                      onChange={handleFileUpload}
                      accept="image/*"
                    />
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "#ffffff" }} id="bold" fill="#ffffff"
                      height="20"
                      viewBox="0 0 24 24"
                      width="20"
                    >
                      <g>
                        <g>
                          <path d="m6.25 19.5c-1.601 0-3.025-1.025-3.542-2.551l-.035-.115c-.122-.404-.173-.744-.173-1.084v-6.818l-2.426 8.098c-.312 1.191.399 2.426 1.592 2.755l15.463 4.141c.193.05.386.074.576.074.996 0 1.906-.661 2.161-1.635l.901-2.865z" />
                        </g>
                        <path d="m9 9c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2z" />
                      </g>
                      <path d="m21.5 2h-15c-1.378 0-2.5 1.122-2.5 2.5v11c0 1.378 1.122 2.5 2.5 2.5h15c1.378 0 2.5-1.122 2.5-2.5v-11c0-1.378-1.122-2.5-2.5-2.5zm-15 2h15c.276 0 .5.224.5.5v7.099l-3.159-3.686c-.335-.393-.82-.603-1.341-.615-.518.003-1.004.233-1.336.631l-3.714 4.458-1.21-1.207c-.684-.684-1.797-.684-2.48 0l-2.76 2.759v-9.439c0-.276.224-.5.5-.5z" />
                    </svg>
                    <span className="ms-3" style={{ color: "#ffffff", fontWeight:"700" }}>UPLOAD</span>
                  </label>
                </div>


              </div>

              <div className="button-section">
                {/* <Button
                  variant="success"
                  className="take-photo-btn"
                  onClick={captureWithFrame}
                >
                  Take Photo
                </Button> */}

                <img
                  src={cameraClick}
                  alt="Capture"
                  onClick={captureWithFrame}
                  style={{ "width": "25%" }}
                />
              </div>



            </Modal.Body>
          </Modal>
        </>
      }
    </>

  );
};

export default CameraModal;